import React from 'react';
import {useIntl} from 'react-intl';
import {useCreateLinkContext} from '../../contexts/CreateLinkContext';
import {StyledFieldInput} from '../../../_common/components/FieldInput';
import InvalidEmailMessage from '../../../_common/components/InvalidEmailMessage';
import FieldRadiobutton from '../../../_common/components/FieldRadiobutton';
import {StyledFieldTextareaAutosize} from '../../../_common/components/FieldTextareaAutosize';
import {usePageContext} from '../../contexts/PageContext';
import ButtonAction from '../../../_common/components/ButtonAction';
import ModalContainer from '../../../_common/components/ModalContainer';
import ModalHeader from '../../../_common/components/ModalHeader';
import ModalContent from '../../../_common/components/ModalContent';
import ModalButtonsContainer from '../../../_common/components/ModalButtonsContainer';
import {buttonCancel, buttonSubmit, largeButtonsPadding} from '../../../_common/styles/styles';
import {useHistory} from "react-router-dom";

const PopupCreateLink = () => {
  const history = useHistory();
  const {formatMessage} = useIntl();
  const prefix = 'price-quote-details';
  const {
    showLinkModal,
    setShowLinkModal,
    priceQuoteID,
  } = usePageContext();
  const {formik, handleCreate, uniqueEmails} = useCreateLinkContext();
  const {handleChange, setFieldValue, values, errors, resetForm, isValid} = formik;
  const handleCloseModal = () => setShowLinkModal(false);
  const header = [
    formatMessage({id: `${prefix}-message-create-link`, defaultMessage: 'Create customer approval link for proposal'}),
    priceQuoteID,
  ].filter(Boolean).join(' ');

  const handleClose = () => {
    handleCloseModal();
    resetForm();
    history.push(`/price-quote-details/${priceQuoteID}`);
  };
  const handleSubmit = async () => {
    await handleCreate();
    handleClose();
  };

  const getRadioEmail = (email: string) => {
    return (
      <FieldRadiobutton
        key={email}
        fieldId="email"
        value={email}
        label={email}
        customContainerStyles="m-1"
        variant="dot"
        onChange={null}
      />
    );
  };

  return (
    <ModalContainer show={showLinkModal} onHide={handleCloseModal} size={'md'}>
      <div>
        <ModalHeader header={header}/>
        <ModalContent customClassnames={'bg-transparent'}>
          <StyledFieldInput
            fieldId={'email'}
            type={'email'}
            label={
              <div>
                <span>{formatMessage({id: `${prefix}-label-email`, defaultMessage: 'Email'})}</span>
                <span className={'text-danger'}>*</span>
              </div> as unknown as string
            }
            value={values.email}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setFieldValue('email', e.target.value)}
            icon={'/media/common/Email_primary.svg'}
            customContainerStyles={'py-3'}
          />
          {errors.email && <InvalidEmailMessage/>}
          {uniqueEmails.length > 0 &&
            <div className={'d-flex mt-6 mb-4'}>{uniqueEmails.map(getRadioEmail)}</div>
          }
          <StyledFieldTextareaAutosize
            fieldId={'notes'}
            label={formatMessage({id: `${prefix}-label-notes`, defaultMessage: 'Notes'})}
            value={values.notes}
            onChange={handleChange}
            customContainerStyles={'py-3'}
          />
          <StyledFieldInput
            {...formik}
            fieldId={'password'}
            label={formatMessage({id: `${prefix}-label-password`, defaultMessage: 'Password'})}
            value={values.password}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setFieldValue('password', e.target.value)}
            customContainerStyles={'py-3'}
            icon={'/media/common/Lock_primary.svg'}
          />
          <StyledFieldInput
            {...formik}
            fieldId={'passwordHint'}
            label={
              <div>
                <span>{formatMessage({id: `${prefix}-label-passwordHint`, defaultMessage: 'Password hint'})}</span>
                {values.password && <span className={'text-danger'}>*</span>}
              </div> as unknown as string
            }
            value={values.passwordHint}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setFieldValue('passwordHint', e.target.value)}
            customContainerStyles={'py-3'}
            icon={'/media/common/Hint_primary.svg'}
          />
        </ModalContent>
        <ModalButtonsContainer customClassnames={largeButtonsPadding}>
          <ButtonAction
            variant={'cancel'}
            onClick={handleClose}
            label={formatMessage({id: 'button-close', defaultMessage: 'Close'})}
            customClassnames={buttonCancel}
          />
          <ButtonAction
            onClick={handleSubmit}
            useIcon={'/media/common/Check-in-circle_white.svg'}
            label={formatMessage({id: 'button-create', defaultMessage: 'Create'})}
            disabled={!isValid}
            customClassnames={buttonSubmit}
          />
        </ModalButtonsContainer>
      </div>
    </ModalContainer>
  );
};

export default PopupCreateLink;